/* eslint-disable no-use-before-define */

import clickOutside from 'click-outside';
import { createFocusTrap } from 'focus-trap';

import announcer from './aria-announcer';

const $navMobile = document.querySelector('.nav-mobile');

if ($navMobile) {
    // Minimum page scroll (px) considered intentional before closing the menu
    const scrollCloseThreshold = 50;

    let focusTrap;
    let unbindClickOutside;
    let scrollStart = 0;

    const $navMobilePanel = $navMobile.querySelector('.nav-mobile-panel');
    const $btnMobileMenu = $navMobile.querySelector('.mobile-menu-btn');
    const $btnMobileMenuLabel = $btnMobileMenu.querySelector('.visuallyhidden');

    // Close menu on escape key
    const onEscape = (event) => {
        if (event.key === 'Escape') {
            closeMobileMenu();
            $btnMobileMenu.focus();
        }
    };

    // Close menu once the page has been scrolled intentionally
    const onScroll = () => {
        if (Math.abs(window.scrollY - scrollStart) > scrollCloseThreshold) {
            closeMobileMenu();
        }
    };

    const openMobileMenu = () => {
        $btnMobileMenu.classList.add('is-open');
        $navMobilePanel.classList.add('is-open');
        $btnMobileMenu.setAttribute('aria-expanded', 'true');
        $btnMobileMenuLabel.textContent = $btnMobileMenu.dataset.labelClose;
        announcer.announce($btnMobileMenu.dataset.announceOpen);

        setTimeout(() => {
            // Menu may have been closed in the meantime
            if (!$btnMobileMenu.classList.contains('is-open')) {
                return;
            }
            // Trap only the toggle button (to close the menu) and the panel links
            focusTrap = createFocusTrap([$btnMobileMenu, $navMobilePanel], {
                allowOutsideClick: true,
                escapeDeactivates: false,
                preventScroll: true,
            });
            focusTrap.activate();
        }, 100);

        unbindClickOutside = clickOutside($navMobile, closeMobileMenu);

        scrollStart = window.scrollY;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('keydown', onEscape);
    };

    const closeMobileMenu = () => {
        $btnMobileMenu.classList.remove('is-open');
        $navMobilePanel.classList.remove('is-open');
        $btnMobileMenu.setAttribute('aria-expanded', 'false');
        $btnMobileMenuLabel.textContent = $btnMobileMenu.dataset.labelOpen;
        announcer.announce($btnMobileMenu.dataset.announceClose);

        if (focusTrap) {
            // Don't pull focus (and the page) back to the button on scroll / click outside
            focusTrap.deactivate({ returnFocus: false });
            focusTrap = null;
        }

        if (unbindClickOutside) {
            unbindClickOutside();
            unbindClickOutside = null;
        }

        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('keydown', onEscape);
    };

    $btnMobileMenu.addEventListener('click', () => {
        if ($btnMobileMenu.classList.contains('is-open')) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    });
}
